module.exports = __webpack_public_path__ + "static/media/gravure1.1f103048.jpg";